<pdq-card variant="flat" color="white">
  <pdq-expandable-section id="multi-shipment-shipping-toggle" [cacheState]="true" [initialCollapsed]="false">
    <div sectionHeader class="section-heading">
      <pdq-heading element="h6">Shipping Toggle</pdq-heading>
      <p class="body-12-regular section-heading__subtitle">
        Buyers can choose single-address or multi-address shipping
      </p>
    </div>

    <div class="shipping-options" [formGroup]="formGroup">
      <div class="shipping-option" formGroupName="singleAddress">
        <div class="shipping-option__header">
          <p class="body-14-medium">Single-address option</p>
          @if (formGroup.controls.defaultSelection.value === 'single') {
            <span class="shipping-option__default body-12-regular">Selected by default</span>
          } @else {
            <pdq-button label="Make default selection" [plain]="true" (onClick)="setDefault('single')"></pdq-button>
          }
        </div>
        <pdq-input
          label="Title"
          formControlName="title"
          placeholder="Ship to one address"
          [invalid]="singleAddressTitleControl.dirty && singleAddressTitleControl.invalid"
          invalidMsg="Title is required"></pdq-input>
        <pdq-textarea
          label="Description"
          [control]="singleAddressControl"
          placeholder="All items go to the same delivery address"
          [invalid]="singleAddressControl.dirty && singleAddressControl.invalid"
          [invalidMessage]="
            singleAddressControl.dirty && singleAddressControl.invalid ? 'Description is required' : ''
          "></pdq-textarea>
      </div>

      <div class="shipping-option" formGroupName="multiAddress">
        <div class="shipping-option__header">
          <p class="body-14-medium">Multi-address option</p>
          @if (formGroup.controls.defaultSelection.value === 'multi') {
            <span class="shipping-option__default body-12-regular">Selected by default</span>
          } @else {
            <pdq-button label="Make default selection" [plain]="true" (onClick)="setDefault('multi')"></pdq-button>
          }
        </div>
        <pdq-input
          label="Title"
          formControlName="title"
          placeholder="Ship to multiple addresses"
          [invalid]="multiAddressTitleControl.dirty && multiAddressTitleControl.invalid"
          invalidMsg="Title is required"></pdq-input>
        <pdq-textarea
          label="Description"
          [control]="multiAddressControl"
          placeholder="Send items to different recipients, each with their own address, date, and gift message"
          [invalid]="multiAddressControl.dirty && multiAddressControl.invalid"
          [invalidMessage]="
            multiAddressControl.dirty && multiAddressControl.invalid ? 'Description is required' : ''
          "></pdq-textarea>
      </div>
    </div>
  </pdq-expandable-section>
</pdq-card>
